var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3778 18.054L11.2429 23.1889C10.9519 23.4799 10.6096 23.6254 10.2159 23.6254C9.8222 23.6254 9.47987 23.4799 9.18889 23.1889C8.89791 22.8979 8.75242 22.5556 8.75242 22.1619C8.75242 21.7682 8.89791 21.4259 9.18889 21.1349L14.3238 16L9.18889 10.8651C8.89791 10.5741 8.75242 10.2318 8.75242 9.83809C8.75242 9.44442 8.89791 9.10209 9.18889 8.81111C9.47987 8.52013 9.8222 8.37464 10.2159 8.37464C10.6096 8.37464 10.9519 8.52013 11.2429 8.81111L16.3778 13.946L21.5127 8.81111C21.8037 8.52013 22.146 8.37464 22.5397 8.37464C22.9334 8.37464 23.2757 8.52013 23.5667 8.81111C23.8576 9.10209 24.0031 9.44442 24.0031 9.83809C24.0031 10.2318 23.8576 10.5741 23.5667 10.8651L18.4317 16L23.5667 21.1349C23.8576 21.4259 24.0031 21.7682 24.0031 22.1619C24.0031 22.5556 23.8576 22.8979 23.5667 23.1889C23.2757 23.4799 22.9334 23.6254 22.5397 23.6254C22.146 23.6254 21.8037 23.4799 21.5127 23.1889L16.3778 18.054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.3083f8bf838e07242e609727d02cd893.svg";
export { ForwardRef as ReactComponent };